import { render, staticRenderFns } from "./mainItem.vue?vue&type=template&id=717c7921&lang=pug&"
import script from "./mainItem.vue?vue&type=script&lang=js&"
export * from "./mainItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports